import React, { Component } from 'react'
import { Box, Text, TextInput, Button, RadioButton } from 'grommet';
import AccessibleSelect from './AccessibleSelect';
import ReactTable from "react-table";
import Modal from 'react-responsive-modal';
// import data from '../Data.json';
import { Image } from 'grommet/components/Image';
import icon from '../Assets/magnifier.svg';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import PropTypes from 'prop-types';
/*import Pagination from './../Components/Pagination';*/
import { SearchPointOfSalesCtrl } from "../Controllers/Transaction/SearchPointOfSalesCtrl";
import { GetPointOfSalesCtrl } from "../Controllers/Ebox/GetPointOfSalesCtrl";
import ModalErrorTimeout from './ModalErrorTimeout';
import { loader, noData } from '../Utils/Utility';

export default class ReportStep1 extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props)
        this.state = {
            selected: '',
            selectedCode: {},
            value: '',
            status: '',
            tablePointofSales: [],
            pages: 0,
            currentPage: 1,
            codSocietario: sessionStorage.getItem('codSocietario'),
            dataReturn: '',
            showTimeoutModal: false,
            openModal: false,
            isRicerca: false
        }

        this.getDetails = this.getDetails.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        this.optionReportList = this.optionReportList.bind(this);
        this.goToPage = this.goToPage.bind(this);
    }

    componentDidMount() {
        if(this.state.codSocietario === '1'){
            var token = sessionStorage.getItem('token');
            var ids = sessionStorage.getItem('ids');
            const self = this;

            this.setState({
                isRicerca: true
            },()=>{

                SearchPointOfSalesCtrl(function (data, pages, currentPage) {
                    self.setState({
                        tablePointofSales: data === undefined ? [] : data,
                        pages: pages === undefined ? 0 : pages,
                        isRicerca: false
                        //currentPage: currentPage === undefined ? [] : currentPage
                    }, sessionStorage.setItem("code", data[0].code));
                }, function (error) {
                    self.setState({
                        status: error
                    }, function(){
                        if(this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403){
                        this.props.history.push({
                            pathname: '/ErrorPage',
                            state: this.state
                        })  
                    } else if (this.state.status === 401) {
                        this.setState({
                            showTimeoutModal: true
                        })
                        // logout();
                        // this.props.history.push({
                        // pathname: '/login'
                        // })
                    } 
                    })
                }, token, ids, this.state.currentPage, this.state.search);
            });
        } else {
            sessionStorage.setItem("code", this.props.values.listaCodPv[0] !== undefined ? this.props.values.listaCodPv[0].code : '');
        }
        
    }

    prevPage(){
        let cp = this.state.currentPage;
        if (cp === 1) return;
        this.setState({
          currentPage: cp - 1
        },() => {
          this.getPointOfSales();
        });
    }
    
    nextPage(){
        let cp = this.state.currentPage;
        if (cp === this.state.pages) return;
        this.setState({
            currentPage: cp + 1
        },() => {
            this.getPointOfSales();
        });
    }

    goToPage(page) {
        if(page === this.state.currentPage) return;
        this.setState({
            currentPage: page
        },() => {
            this.getPointOfSales();
        });
    }

    getPointOfSales() {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const self = this;
        SearchPointOfSalesCtrl(function (data, pages, currentPage) {
          self.setState({
            tablePointofSales: data === undefined ? [] : data,
            pages: pages === undefined ? 0 : pages,
            //currentPage: currentPage === undefined ? [] : currentPage
          });
        }, function (error) {
          self.setState({
            status: error
          }, function() {
            if(this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403){
              this.props.history.push({
                  pathname: '/ErrorPage',
                  state: this.state
              })  
          } else if (this.state.status === 401) {
                this.setState({
                    showTimeoutModal: true
                })
            //   logout();
            //   this.props.history.push({
            //   pathname: '/login'
            //   })
          } 
          })
    
        }, token, ids, this.state.currentPage, this.state.search);
    }
    
    onCloseModal = () => {
        this.setState({ openModal: false });
    };

    setPoint(i, row) {
        sessionStorage.setItem("i", i);
        if (sessionStorage.getItem("i", i)) {
            this.setState({
                value: parseInt(sessionStorage.getItem("i", i)),
                selected: parseInt(sessionStorage.getItem("i", i)),
                selectedCode: row.original
            });

        } else {
            this.setState({ value: null });
        }
        sessionStorage.setItem("code", this.state.tablePointofSales[i].code);
    }

    setPointGestore(i, row) {
        sessionStorage.setItem("i", i);
        if (sessionStorage.getItem("i", i)) {
            this.setState({
                value: parseInt(sessionStorage.getItem("i", i)),
                selected: parseInt(sessionStorage.getItem("i", i)),
                selectedCode: row.code
            });

        } else {
            this.setState({ value: null });
        }
        sessionStorage.setItem("code", this.props.values.listaCodPv[i].code);
    }
    
    optionReportList() {
        return this.props.values.optionsReport.map(el => el.label)
    }

    getDetails(i) {
        var token = sessionStorage.getItem('token');
        var ids = sessionStorage.getItem('ids');
        var selectedCode = this.props.values.listaCodPv[i].code;
        const self = this;
        sessionStorage.setItem("i", i);
        GetPointOfSalesCtrl(function (data) {
          self.setState({
            dataReturn: data,
            openModal: true
          });
        }, function (error) {
          self.setState({
            status: error
          }, function() {
            if(this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403){
                self.props.history.push({
                  pathname: '/ErrorPage',
                  state: this.state
              })  
          } else if (this.state.status === 401) {
                this.setState({
                    showTimeoutModal: true
                })
            //   logout();
            //   self.props.history.push({
            //     pathname: '/login'
            //   })
          } 
          })
    
        }, selectedCode, token, ids);
    }

    render() {

        const columns = [
            {
                Header: '',
                Cell: row => (
                    <div>
                        <RadioButton
                            id={"radio" + [row.index]}
                            className="radiobutton"
                            label={row.insegna}
                            checked={this.state.selected === row.index ? true : false}
                            onChange={this.setPoint.bind(this, row.index, row)}
                            value={row.index}
                        />
                    </div>
                ),
                headerClassName: 'sH',
                maxWidth: 50
            },
            {
                Header: 'Insegna',
                accessor: 'name',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'Codice esercizio',
                accessor: 'code',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'Indirizzo',
                accessor: 'address',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'Città',
                accessor: 'city',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },

        ]

        const columnsGestore = [
            {
                Header: '',
                Cell: row => (
                    <div>
                        <RadioButton
                            id={"radio" + [row.index]}
                            className="radiobutton"
                            label={row.codice}
                            checked={this.state.selected === row.index ? true : false}
                            onChange={this.setPointGestore.bind(this, row.index, row)}
                            value={row.index}
                        />
                    </div>
                ),
                headerClassName: 'sH',
                maxWidth: 50
            },
            {
                Header: 'codice',
                accessor: 'code',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'Dettagli',
                Cell: row => (
                    <div style={{width:'14px', margin: 'auto', cursor: 'pointer'}} onClick={(e) => { e.preventDefault(); this.getDetails(row.index)}} >
                        <Image
                            style={{width:'14px'}} 
                            id='magnifier'
                            src={icon}
                            alt="detail"
                            
                        />
                    </div> 
                ),
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            }
        ]

        const hasData = (Array.isArray(this.state.tablePointofSales) && this.state.tablePointofSales.length > 0 && this.state.tablePointofSales !== null && this.state.tablePointofSales !== undefined)
        
        return (
            <Box className='contentbox'>
                {this.state.showTimeoutModal && <ModalErrorTimeout />}
                <Box pad='medium' align='start'>
                    <Text className='titlehome'>REPORT DISPUTE</Text>
                </Box>
                <Box direction='row'>
                    <Box pad='large' className='table'>
                        {!hasData ? (
                            this.state.isRicerca ? loader : noData
                        ) : this.state.codSocietario === '1' ? (
                            <>
                                <ReactTable
                                    key="table"
                                    data={this.state.tablePointofSales}
                                    columns={columns}
                                    sortable={true}
                                    multiSort={true}
                                    resizable={true}
                                    showPagination={false}
                                    loading={false}
                                    defaultPageSize={this.state.tablePointofSales.length}
                                    style={{ paddingBottom: '20px' }}
                                />
                                <div key="pagination">
                                    <div style={{height: '50px', display: 'flex-wrap', flexDirection: 'row'}}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <button
                                                disabled={this.state.currentPage === 1}
                                                onClick={() => this.goToPage(1)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                        e.preventDefault();
                                                        this.goToPage(1);
                                                    }
                                                }}
                                                aria-label="Vai alla prima pagina"
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    color: this.state.currentPage === 1 ? '#999' : '#006fcf',
                                                    cursor: this.state.currentPage === 1 ? 'not-allowed' : 'pointer',
                                                    padding: '5px',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    outline: 'none',
                                                    width: '20px'
                                                }}
                                            >
                                                <i className='icon-double-left' style={{fontSize:'12px'}} aria-hidden="true" />
                                            </button>
                                            <button
                                                disabled={this.state.currentPage === 1}
                                                onClick={() => this.prevPage()}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                        e.preventDefault();
                                                        this.prevPage();
                                                    }
                                                }}
                                                aria-label="Pagina precedente"
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    color: this.state.currentPage === 1 ? '#999' : '#006fcf',
                                                    cursor: this.state.currentPage === 1 ? 'not-allowed' : 'pointer',
                                                    padding: '5px',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    outline: 'none',
                                                    width: '20px'
                                                }}
                                            >
                                                <i className='icon-left-chevron' style={{fontSize:'12px'}} aria-hidden="true" />
                                            </button>

                                            {/* POSITION PAGE */}
                                            <Text className='pag' style={{fontSize:'12px', marginBottom: '12px', whiteSpace: 'nowrap'}}>
                                                {this.state.currentPage} di {this.state.pages}
                                            </Text>

                                            {/* NEXT PAGE */}
                                            <button
                                                disabled={this.state.currentPage === this.state.pages}
                                                onClick={() => this.nextPage()}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                        e.preventDefault();
                                                        this.nextPage();
                                                    }
                                                }}
                                                aria-label="Pagina successiva"
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    color: this.state.currentPage === this.state.pages ? '#999' : '#006fcf',
                                                    cursor: this.state.currentPage === this.state.pages ? 'not-allowed' : 'pointer',
                                                    padding: '5px',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    outline: 'none',
                                                    width: '20px'
                                                }}
                                            >
                                                <i className='icon-right-chevron' style={{fontSize:'12px'}} aria-hidden="true" />
                                            </button>
                                            <button
                                                disabled={this.state.currentPage === this.state.pages}
                                                onClick={() => this.goToPage(this.state.pages)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                        e.preventDefault();
                                                        this.goToPage(this.state.pages);
                                                    }
                                                }}
                                                aria-label="Vai all'ultima pagina"
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    color: this.state.currentPage === this.state.pages ? '#999' : '#006fcf',
                                                    cursor: this.state.currentPage === this.state.pages ? 'not-allowed' : 'pointer',
                                                    padding: '5px',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    outline: 'none',
                                                    width: '20px'
                                                }}
                                            >
                                                <i className='icon-double-right' style={{fontSize:'12px'}} aria-hidden="true" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <ReactTable
                                data={this.props.values.listaCodPv || []}
                                columns={columnsGestore}
                                sortable={true}
                                multiSort={true}
                                resizable={true}
                                showPagination={false}
                                loading={false}
                                defaultPageSize={10}
                                style={{ paddingBottom: '20px' }}
                            />
                        )}
                    </Box>
                </Box>
                <Box direction='row' alignSelf='center'>
                    <Box>
                        <Box direction='row' gap='medium'>
                            <Box direction='column'>
                                <Text className='label' id='statusDisputa-label' htmlFor='statusDisputa' aria-hidden="false">Stato:</Text>
                                <AccessibleSelect 
                                    id='statusDisputa' 
                                    className='selectCustom' 
                                    placeholder='Seleziona Stato' 
                                    value={this.props.values.statusDisputa} 
                                    options={this.optionReportList()} 
                                    onChange={(e) => this.props.setStatusDisputa(e)} 
                                    aria-labelledby='statusDisputa-label'
                                    aria-required='true'
                                    a11yTitle='Stato'
                                    dropAlign={{ top: 'bottom' }}
                                    dropProps={{
                                        a11yTitle: 'Opzioni di stato disponibili',
                                        role: 'listbox',
                                        'aria-multiselectable': 'false'
                                    }}
                                    messages={{
                                        multiple: 'Selezionato',
                                        selected: 'Selezionato'
                                    }}
                                />
                            </Box>
                            <Box direction='column'>
                                <Text className='label'>Numero Carta:</Text>
                                <TextInput 
                                    style={{ border: '1px solid rgba(0, 0, 0, 0.33)' }} 
                                    id='numcarta' 
                                    size='medium' 
                                    className='inputForm' 
                                    maxLength={19} 
                                    value={this.props.piva} 
                                    onChange={this.props.setNumeroCarta} 
                                    onBlur={this.props.validNumber} 
                                />
                                {this.props.values.msgNum ? (
                                    <Text className='error'>{this.props.values.msgNum}</Text>
                                ) : (
                                    <Text className='errorhide' />
                                )}
                            </Box>
                        </Box>
                        <Box direction='row' gap='medium' margin={{ top: 'medium' }}>
                            <Box direction='column'>
                                <Text className='label'>Data da:</Text>
                                <DatePicker
                                    selected={this.props.values.startDate}
                                    selectsStart
                                    dateFormat='dd/MM/yyyy'
                                    startDate={this.props.values.startDate}
                                    endDate={this.props.values.endDate}
                                    onChange={this.props.handleChangeStartDate}
                                    className='inputForm datePicker'
                                    maxDate={new Date()}
                                />
                            </Box>
                            <Box direction='column'>
                                <Text className='label'>al:</Text>
                                <DatePicker
                                    selected={this.props.values.endDate}
                                    selectsEnd
                                    dateFormat='dd/MM/yyyy'
                                    startDate={this.props.values.startDate}
                                    endDate={this.props.values.endDate}
                                    onChange={this.props.handleChangeEndDate}
                                    className='inputForm datePicker'
                                    maxDate={new Date()}
                                />
                            </Box>
                        </Box>
                        <Box style={{ margin: '24px 0' }} align='center'>
                            <Box direction='row' style={{ width: '100%' }}>
                                <Button 
                                    className='btnform' 
                                    style={{ width: '100%' }} 
                                    onClick={this.props.detailReport}
                                    primary
                                    label='CERCA'
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>

                <div>
                    <Modal open={this.state.openModal} onClose={this.onCloseModal} center>
                        <br></br>
                        <Text style={{color: 'red', fontWeight: 'bold'}}>Dettagli Punto Vendita</Text>
                        <br></br>
                        <Text><b>Insegna:</b> {this.state.dataReturn.name}</Text><br></br>
                        <Text><b>Codice Punto vendita:</b> {this.state.dataReturn.code}</Text><br></br>
                        <Text><b>Città:</b> {this.state.dataReturn.city}</Text><br></br>
                        <Text><b>Indirizzo:</b> {this.state.dataReturn.address}</Text><br></br>
                        <br></br>
                    </Modal>
                </div>
            </Box>

        )
    }
}